import { loadGlobalScript } from './load-global';
import jqueryCode from './jquery.min.js?raw';
loadGlobalScript(jqueryCode);
export default window.jQuery;